import styled from "styled-components";
import { lighten } from "polished";
import vars from "../../styles/vars";
import { ButtonWrapper } from "../button/styles";

export const IntroLayoutWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
`;
type Props = {
  browser: string;
};

export const IntroContainer = styled.div<Props>`
  display: flex;
  flex-wrap: wrap;
  overflow-x: hidden;
  overflow-y: auto;
  max-width: 1100px;
  width: 80vw;
  margin: ${({ browser }) => (browser === "ie" ? 0 : "auto")};

  & > div {
    /* flex: 1; */
    flex: 1 1 300px;
    min-width: 0;
    background-color: white;
  }

  @media (max-width: 1100px) {
    width: calc(100vw - 100px);
  }

  @media (max-width: 700px) {
    width: calc(100vw - 50px);
  }

  @media (max-width: 500px) {
    width: calc(100vw - 30px);
  }
`;

type IntroBannerProps = {
  backgroundImage: string;
};

export const IntroBanner = styled.div<IntroBannerProps>`
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-size: cover;
  background-position: center;
  height: 15vw;
  width: 100%;
  min-height: 200px;

  @media (max-width: 600px) {
    min-height: 150px;
  }
`;

export const ImageBlock = styled.div<{ $bgImg: string }>`
  background-image: ${({ $bgImg }) => `url(${$bgImg})`};
  background-size: cover;
  background-position: center;
`;

export const ItemsContainer = styled.div`
  display: flex;
  padding: 2rem;

  @media (max-width: ${vars.responsiveMin}px) {
    flex-direction: column;
    padding: 0 1em;
  }
`;

export const ItemContainer = styled.div`
  display: grid;
  place-content: center;

  @media (max-width: 850px) {
    flex: 100%;
    width: 100%;
  }
`;

export const TitleBox = styled.div`
  min-height: 100px;
  padding: 2em 2em 4em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  outline: none;
  & h1 {
    font-family: ${vars.fontTertiary};
  }

  @media (max-width: ${vars.responsiveMin}px) {
    padding: 0 1em 0 1em;
    & h1 {
      font-size: 1.5em;
    }
  }
`;

type DescriptionBoxProps = {
  primaryColor: string;
};

export const DescriptionBox = styled.div<DescriptionBoxProps>`
  min-height: 100px;
  padding: 0 2em;
  display: grid;
  gap: 1rem;

  & p,
  & span {
    font-size: 1em;
    font-weight: normal;
    line-height: 1.2;
  }

  & p {
    .ql-size-small {
      font-size: 0.75em;
    }

    .ql-size-normal {
      font-size: 1em;
    }

    .ql-size-large {
      font-size: 1.2em;
    }

    & .ql-size-huge {
      font-size: 1.6em;
    }

    @media (max-width: 600px) {
      font-size: 0.8em;

      .ql-size-small {
        font-size: 0.6em;
      }

      .ql-size-normal {
        font-size: 0.8em;
      }

      .ql-size-large {
        font-size: 1em;
      }

      & .ql-size-huge {
        font-size: 1.3em;
      }
    }
  }

  & ${ButtonWrapper} {
    //background-color: #000;
    //border: 1px solid #7c7d7c;
    width: fit-content;
    padding-inline: 2rem;
  }

  @media (max-width: ${vars.responsiveMin}px) {
    padding: 2em 1em;
  }

  @media (max-width: 680px) {
    height: auto;
    flex-direction: column;
    align-items: flex-start;
    padding: 2em 0em;

    & p {
      font-size: 1em;
    }

    & span {
      display: block;
      &:last-child {
        margin: 0.7em 0;
      }
    }

    & > *:first-child {
      margin: 0.7em 0;
    }
  }
`;

export const LogoContainer = styled.div`
  // flex: 20%;
  // width: 20%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  // flex-direction: column;

  @media (max-width: ${vars.responsiveMin}px) {
    // flex-direction: row-reverse;
    flex: 100%;
    width: 100%;
  }
`;

type EmptyBoxProps = {
  primaryColor: string;
};

export const EmptyBox = styled.div<EmptyBoxProps>`
  width: 100%;
  background-color: ${({ primaryColor }) => {
    const amount = 0.5;
    try {
      return lighten(amount, `${primaryColor}`);
    } catch {
      return lighten(amount, "#000");
    }
  }};
  height: 8vw;
  min-height: 100px;

  @media (max-width: ${vars.responsiveMin}px) {
    flex: 80%;
    width: 80%;
  }
`;

export const LogoBox = styled.div`
  height: 8vw;
  min-height: 100px;
  position: relative;
  display: grid;
  place-items: center;
  padding: 2em;

  & img {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    max-width: 70px;
    max-height: 70px;
    width: 100%;
  }

  @media (max-width: ${vars.responsiveMin}px) {
    // flex: 20%;
    width: 20%;
    padding: 0;
  }
`;
